<template>
  <button
      type="button"
      class="theme-toggle"
      :aria-label="`Switch to ${other} mode`"
      :title="`Switch to ${other} mode`"
      @click="toggle"
  >
    <i :class="theme === 'night' ? 'fa-solid fa-moon' : 'fa-solid fa-sun'"></i>
    <span>{{ theme === 'night' ? 'Night' : 'Day' }}</span>
  </button>
</template>

<script>
import { readTheme, applyTheme } from '@/theme'

export default {
  name: 'ThemeToggle',
  data() {
    return { theme: readTheme() }
  },
  computed: {
    other() {
      return this.theme === 'night' ? 'day' : 'night'
    },
  },
  methods: {
    toggle() {
      this.theme = applyTheme(this.other)
    },
  },
  mounted() {
    // The inline script in index.html already set the attribute before paint;
    // this keeps the button's label in step if storage was written elsewhere.
    this.theme = applyTheme(readTheme())
  },
}
</script>

<style scoped>
@import './TruckList.css';
</style>
